define('presentation/welcome/viewModels/onboardingInProgressViewModel',[
    'businessServices/authentication/sessionWorkflowFlags',
    'businessServices/login/accountStatusEvaluator',
    'businessServices/onboarding/liveReceptionistOnboardingSingleton',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'constants/colorConstants',
    'presentation/welcome/common/onboardingNavigationManager',
    'presentation/welcome/facades/onboardingInProgressFacade',
    'settings/navigationConfiguration'
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _accountStatusEvaluator = require('businessServices/login/accountStatusEvaluator');
        const _colorConstants = require('constants/colorConstants');
        const _i18n = require('i18next');
        const _liveReceptionistOnboardingState = require('businessServices/onboarding/liveReceptionistOnboardingSingleton');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _router = require('businessServices/router/router');
        const _sessionWorkflowFlags = require('businessServices/authentication/sessionWorkflowFlags');

        let _facade = null;
        let _onboardingNavigationManager = null;

        const STEP_TIMING = {
            processingDelay: 3000,
            completionDelay: 1000
        };

        self.isCompositionComplete = ko.observable(false);
        self.isMinContentContainer = true;
        self.isCenteredContentContainer = true;
        self.spinnerColor = _colorConstants.colorSecondaryWarm400;
        self.currentStepMessage = ko.observable('');
        self.onboardingProgressSteps = ko.observableArray([
            {
                id: "script",
                title: _i18n.t('onboardingInProgress:stepScript'),
                sequence: 1
            },
            {
                id: "callflow",
                title: _i18n.t('onboardingInProgress:stepCallflow'),
                sequence: 2
            },
            {
                id: "trial",
                title: _i18n.t('onboardingInProgress:stepTrial'),
                sequence: 3
            }
        ]);

        const _onLiveReceptionistOnboardingCompleted = () => {
            _liveReceptionistOnboardingState.clear();
            _accountStatusEvaluator.refresh();

            if (_sessionWorkflowFlags.onboardingSpecialistRequested()) {
                _sessionWorkflowFlags.onboardingSpecialistRequested(false);
                _sessionWorkflowFlags.isSchedulingAfterOnboardingWizard(true);
                _onboardingNavigationManager.navigateToSchedulingPage();
                return;
            }

            _router.navigate(_navigationConfiguration.signupLandingPage);
        };

        const _simulateStepProgress = (step) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                self.currentStepMessage(step.title);
                setTimeout(() => {
                    setTimeout(() => {
                        deferredObject.resolve();
                    }, STEP_TIMING.completionDelay);
                }, STEP_TIMING.processingDelay);
            });
        };

        const _simulateOnboardingProgress = () => {
            return _promiseFactory.deferWithMinimumWait((deferredObject) => {
                _promiseFactory.deferredList(self.onboardingProgressSteps(), _simulateStepProgress)
                    .fail(deferredObject.reject)
                    .done(deferredObject.resolve);
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
            _simulateOnboardingProgress();
        };

        self.detached = () => {
            _facade.dispose();
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/welcome/facades/onboardingInProgressFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const OnboardingNavigationManagerConstructor = require('presentation/welcome/common/onboardingNavigationManager');
            _onboardingNavigationManager = new OnboardingNavigationManagerConstructor();
            _onboardingNavigationManager.init();

            return _initialize();
        };

        const _initialize = () => {

            _facade.onLiveReceptionistOnboardingCompleted(_onLiveReceptionistOnboardingCompleted);

            return _promiseFactory.wait();
        };
    };
});

